import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { ConfirmedValidator } from 'src/app/validators/password-validation.service';
import { DeliveryNewPasswordDto, DeliveryService } from 'src/generated_client';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {

  deliveryName: string = '';
  deliveryId: number = 0;

  changePasswordForm = this.fb.group({
    oldPassword: ['', Validators.required],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    confirmPassword: ['', Validators.required],
  }, {
    validator: ConfirmedValidator('password', 'confirmPassword')
  })

  constructor(
    public localStorageService: LocalStorageService,
    public deliveryService: DeliveryService,
    public toastService: ToastService,
    private fb: FormBuilder,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.deliveryName = this.localStorageService.getItem('dsName');
    this.deliveryId = Number(this.localStorageService.getDeliveryId());
  }

  changePassword(form: any) {
    let delivery: DeliveryNewPasswordDto = {
      cdDelivery: this.deliveryId,
      dsPassword: form.oldPassword,
      dsNewPassword: form.password,
    }
    this.deliveryService.apiDeliveryChangePasswordPut(delivery).subscribe(response => {
      this.toastService.presentToast("Contraseña cambiada con éxito");
      this.dismiss();
    }, error => {
      this.toastService.presentToast("La contraseña no pudo ser cambiada")
    })
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  get password() {
    return this.changePasswordForm.get('password');
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword');
  }

  get oldPassword() {
    return this.changePasswordForm.get('oldPassword');
  }

}
